import { render, staticRenderFns } from "./ReportsView.vue?vue&type=template&id=a0b52f6c&lang=pug"
import script from "./ReportsView.vue?vue&type=script&lang=ts"
export * from "./ReportsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0b52f6c')) {
      api.createRecord('a0b52f6c', component.options)
    } else {
      api.reload('a0b52f6c', component.options)
    }
    module.hot.accept("./ReportsView.vue?vue&type=template&id=a0b52f6c&lang=pug", function () {
      api.rerender('a0b52f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Reports/ReportsView.vue"
export default component.exports